// Eine Tabelle ist in dieser Anwendung immer eine echte <table>: die Struktur steht in der
// Auszeichnung, nicht in der Linienführung (parts4/00-contract.md, „Accessibility"). Die
// Beschriftung ist Pflicht — ohne sie heißt die Tabelle im Verzeichnis eines Bildschirmlesers
// „Tabelle 3 von 4".
import type { ReactElement, ReactNode } from 'react'
import './bausteine.css'

export interface TabelleProps {
  /** Der zugängliche Name. Pflicht. */
  beschriftung: string
  /** Die Kopfzeile(n): ein oder mehrere <tr> mit <th scope="col">. */
  kopf: ReactNode
  /** Summen- oder Abschlusszeile(n) als <tr>. */
  fuss?: ReactNode
  /** Die Datenzeilen als <tr>. */
  children: ReactNode
}

export function Tabelle({ beschriftung, kopf, fuss, children }: TabelleProps): ReactElement {
  // Der Rahmen trägt Fläche, Rundung und Schatten — und scrollt waagerecht, wenn eine breite Tabelle
  // nicht in die Spalte passt. Auf der <table> selbst würde `overflow: hidden` die Spalten abschneiden.
  return (
    <div className="tabelle-rahmen">
      <table className="tabelle" aria-label={beschriftung}>
        <caption className="nur-vorlesen">{beschriftung}</caption>
        <thead>{kopf}</thead>
        <tbody>{children}</tbody>
        {fuss === undefined ? null : <tfoot>{fuss}</tfoot>}
      </table>
    </div>
  )
}
